import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class AdjOpeningReserveBalancesService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveLocalPurchaseAdj(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData) return of({ callSuccess: '0', errorMessage: 'Row data is required.' });
    data.rowData.ADJUSTED_BALANCE = parseInt(data.rowData.BOY_AMT, 10) + parseInt(data.rowData.ADJUSTMENTS, 10);
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonObj: JSON.stringify(data.rowData),
      jsonSettings: '{}',
      process_name: 'saveLocalPurchaseAdj'
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=o2v5nd`,
      params,
      globalService,
      filterParams
    );
  }
}
